<template>
  <div>
    <section v-if="showTitle" class="avatar_sect_title" :class="{ has_error: invalid }">
      <h2>{{ $_getTranslations.common_carousel_select_avatar }}</h2>
    </section>
    <section class="avatar_sect" :class="{ has_error: invalid }">
      <div class="swiper-container avatar-swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="imageIndex in avatarMixinGroupSize" :key="imageIndex.type">
            <div class="carousel-item">
              <div class="user_img_bg">
                <img :src="getAvatarImage(imageIndex)" @click.prevent="changeSelectedAvatar(imageIndex)" :key="imageIndex" :alt="'Avatar ' + imageIndex">
              </div>
            </div>
          </div>
          <!-- Add more slides as needed -->
        </div>
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
      </div>
    </section>
  </div>
</template>

<script>
import translationMixin from "../../../common/mixins/translation";
import avatarMixin from '../../../common/mixins/avatar';

const swiperDefaultOptions = {
  slidesPerView: 2,
  spaceBetween: 0,
  centeredSlides: false,
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  on: {
    init: function () {
      this.slideToLoop(1, 0, true);
    },
  },
}

export default {
  name: 'AvatarSelectionCarousel',
  mixins: [
    translationMixin,
    avatarMixin
  ],
  props: {
    showTitle: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: "register",
      validator: function (value) {
        // The value must match one of these strings
        return ['profile', 'register'].includes(value)
      },
    },
    invalid: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      selectedAvatar: 1,
      avatarSwiper: null,
      swiperOptionsPerType: {
        profile: {
          slidesPerView: 3,
          breakpoints: {
            600: {
              slidesPerView: 4,
              spaceBetween: 10,
              centeredSlides: false,
            },
            360: {
              slidesPerView: 3,
              spaceBetween: 10,
              centeredSlides: true,
            },

            0: {
              slidesPerView: 2,
              spaceBetween: 10,
              centeredSlides: false,
            }
          },
        },
        register:{
          breakpoints: {
            510: {
              slidesPerView: 3,
              spaceBetween: 10,
              centeredSlides: false,
            },
            370: {
              slidesPerView: 2,
              spaceBetween: 10,
              centeredSlides: true,
            },
          },
        },
      },


    };
  },
  mounted() {
    this.initAvatarSwiper();
  },
  methods: {
    getAvatarImage(imageIndex) {
      return `/static/images/avatars/set${this.avatarMixinGroupId}/avatar_${imageIndex < 10 ? '0' + imageIndex : imageIndex}.png`;
    },
    changeSelectedAvatar(index) {
      this.selectedAvatar = index;
      console.log(index);
      localStorage.setItem('Avatar', this.getAvatarImage(index));

      if (this.type === 'profile'){
        this.$emit('avatar-selected', index);
      } else {
        this.$emit('avatar-selected'); // Emit an event to notify the parent
      }
    },
    initAvatarSwiper() {
      /* eslint-disable */
      if (this.avatarSwiper) {
        this.avatarSwiper = null;
      }

      this.avatarSwiper = new Swiper('.avatar-swiper', {
        ...swiperDefaultOptions,
        ...this.swiperOptionsPerType[this.type],
      });
      $(document).ready(() => {
        $('.avatar-swiper .carousel-item .user_img_bg').on('click', function () {
          $('.avatar-swiper .carousel-item .user_img_bg').removeClass('selected_avatar');
          $(this).addClass('selected_avatar');
        });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/carousel/AvatarSelectionCarousel.vue